import { createFileRoute, Navigate } from "@tanstack/react-router";

function IntegrationsSettingsPage() {
  return <Navigate to="/settings/api-integrations" replace />;
}

export const Route = createFileRoute("/settings/integrations")({
  component: IntegrationsSettingsPage,
});
